import { getStore } from "@scripts-admin/utils/safe-store";
import initAjaxSelect2 from "@scripts/services/init-ajax-select2";
import fetchGetRedRestApi from "@scripts/services/fetch-get-red-rest-api";

export default (initial = {}) => ({
    storeName: initial.store ?? null,
    id: initial.id ?? null,
    loading: false,
    selectedCourse: 0,
    preview: null,

    async init() {
        this.$st = getStore(this.storeName ?? '') || {};
        if (typeof this.$st.selectedCourse !== 'undefined') {
            this._syncSelectedCourseFromStore(this.$st.selectedCourse);
        }

        try {
            jQuery(() => {
                this.select2Courses = jQuery(this.$refs.select).select2({
                    placeholder: 'Виберіть курс', ...initAjaxSelect2(
                        `${rozetka_learnpress_global.restApi.url}courses`,
                        { user_id: this.userId, mode: 'assign' },
                        rozetka_learnpress_global.restApi.nonce
                    )
                });

                this.select2Courses.on("select2:select", (event) => {
                    this.selectedCourse = event.target.value
                });

                if (this.selectedCourse) {
                    this.select2Courses.val(this.selectedCourse).trigger('change.select2');
                }
            })
        } catch (error) {
            console.error(error)
        }

        this.$watch(() => this.selectedCourse, async (v) => {
            this.$st.selectedCourse = v;

            if (v === 0) {
                this.preview = null;
                return;
            }

            try {
                this.preview = 'loading';

                const { success, data, message } = await fetchGetRedRestApi('course-preview', {
                    course_id: v,
                });

                if (success) {
                    this.preview = { ...data };
                } else {
                    throw new Error(`Course preview error! Message: ${message}`);
                    this.preview = null;
                }
            } catch (error) {
                console.error(error)
            }
        });

        this.$watch(() => this.$st?.selectedCourse, (value) => {
            if (typeof value === 'undefined') {
                return;
            }
            this._syncSelectedCourseFromStore(value);
        });
    },

    _syncSelectedCourseFromStore(value) {
        const normalized = value ?? 0;
        const current = this.selectedCourse ?? 0;
        if (`${normalized}` === `${current}`) {
            return;
        }
        this.selectedCourse = normalized;
        if (this.select2Courses) {
            this.select2Courses.val(normalized || null).trigger('change.select2');
        }
    },
});
